import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { Col, DatePicker, Form, Radio, RadioChangeEvent, Row } from "antd";
import type { SourcingRequirementApplicationFormFields } from "../type";
import styles from "@/asserts/styles/formSection.module.less";

type Props = {
  editable: boolean;
  show: boolean;
};

export const FormulaChangeFields = ({ show, editable }: Props) => {
  const form = Form.useFormInstance<SourcingRequirementApplicationFormFields>();

  const formulaChange = Form.useWatch("formulaChange", form);

  const showChangeTimeField = formulaChange?.toString() === "1";

  const onFormulaChange = (e: RadioChangeEvent) => {
    // 当处方变更状态修改时，重置预计处方变更完成时间
    form.setFieldValue("changedTime", null);
  };

  if (!show) return;

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title="处方变更确认" />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={12}>
            <Form.Item<SourcingRequirementApplicationFormFields>
              name="formulaChange"
              label="寻源物料之产品是否正在处方变更"
              rules={[
                {
                  required: true,
                  message: "请选择产品是否正在处方变更",
                },
              ]}
            >
              <Radio.Group
                disabled={!editable}
                options={[
                  { value: 1, label: "是" },
                  { value: 0, label: "否" },
                ]}
                onChange={onFormulaChange}
              />
            </Form.Item>
          </Col>

          {showChangeTimeField && (
            <Col span={12}>
              <Form.Item<SourcingRequirementApplicationFormFields>
                name="changedTime"
                label="预计处方变更完成时间"
                rules={[
                  {
                    required: true,
                    message: "请选择预计处方变更完成时间",
                  },
                ]}
              >
                <DatePicker disabled={!editable} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
};
